import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { saveAs } from "file-saver-es";
import React, { useEffect, useState } from "react";

import { malgun } from "../malgun";
import {
  CLINIC_STEP_NAME,
  CLST_PRPOS_CD_NM,
  DMINT_DIVS_CD_NM,
  RNDM_ASSG_CD_NM,
  CLNC_TEST_DTL_CD_NM,
  YN,
  BLND_CD_NM,
} from "../MdcinClincTestInfoService01/data";

import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { DataGrid, Button } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Export,
  FilterRow,
  Grouping,
  GroupItem,
  GroupPanel,
  HeaderFilter,
  Item,
  LoadPanel,
  Lookup,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
  StateStoring,
  Summary,
  Toolbar,
} from "devextreme-react/data-grid";

import "./index.css";
// import InspctManagerNameRender from "./InspctManagerNameRender";

export default function MdcinClincTestInfoService01Grid(props) {
  const { blind } = props;

  const [dataSource, setDataSource] = useState(null);
  // const [blind, setBlind] = useState(false);

  const dataGridRef = React.createRef();
  const pageSize = [10, 20, 50, 100];

  useEffect(() => {
    axios
      .get(
        // `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01?LAB_SEQ=${props.data.key}`
        `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01?LAB_SEQ=${props.data.LAB_SEQ}`
      )
      .then((result) => {
        setDataSource(result.data);
      })
      .catch((error) => console.log(error));
  }, [props.data.LAB_SEQ]);

  const exportGrid = React.useCallback(() => {
    const doc = new jsPDF("l", "mm", [297, 210]);

    doc.addFileToVFS("malgun.ttf", malgun);
    doc.addFont("malgun.ttf", "malgun", "normal");
    doc.setFont("malgun");

    const dataGrid = dataGridRef.current.instance;

    exportDataGridToPDF({
      jsPDFDocument: doc,
      component: dataGrid,
      autoTableOptions: {
        styles: {
          font: "malgun",
        },
      },
    }).then(() => {
      doc.save("식품의약품안전처_의약품 임상시험 정보.pdf");
    });
  });

  const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("의약품 임상시험 정보");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/octet-stream",
          }),
          "식품의약품안전처_의약품 임상시험 정보.xlsx"
        );
      });
    });

    e.cancel = true;
  };

  function inspctManagerNameRender(itemInfo) {
    if (blind) {
      return (
        <div>
          {itemInfo.column.caption}:{" "}
          {maskInvestigatorName(itemInfo.data.key)}
          (Count: {itemInfo.data.aggregates[0]})
        </div>
      );
    } else {
      return (
        <div>
          {itemInfo.column.caption}: {itemInfo.data.key} (Count:{" "}
          {itemInfo.data.aggregates[0]})
        </div>
      );
    }
  }

  function maskInvestigatorName(name) {
    if (!name) {
      return "";
    }

    return name[0] + "*".repeat(Math.max(name.length - 1, 0));
  }

  function jointInvestigatorRender(itemInfo) {
    const names = itemInfo.data.CO_INSPCT_MANAGER_NAMES || [];

    if (names.length === 0) {
      return <span>-</span>;
    }

    return (
      <span>
        {blind ? names.map(maskInvestigatorName).join(", ") : names.join(", ")}
      </span>
    );
  }

  function applyEntpNameRender(itemInfo) {
    if (blind) {
      return (
        <div>
          {itemInfo.data.APPLY_ENTP_NAME[0] +
            "*".repeat(itemInfo.data.APPLY_ENTP_NAME.length - 1)}
        </div>
      );
    } else {
      return <div>{itemInfo.data.APPLY_ENTP_NAME}</div>;
    }
  }

  // const handleBlind = () => {
  //   setBlind(!blind);
  // };

  return (
    <React.Fragment>
      <DataGrid
        id="MdcinClincTestInfoService01Grid"
        ref={dataGridRef}
        dataSource={dataSource}
        keyExpr="ROW_KEY"
        rowAlternationEnabled={true}
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
        onExporting={onExporting}
      >
        <ColumnChooser enabled={true} />
        <LoadPanel enabled={true} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />

        <GroupPanel visible={true} />
        <SearchPanel visible={true} highlightCaseSensitive={true} />

        <Paging enabled={true} />
        <Grouping autoExpandAll={false} />

        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={
            "ClinicTestOprtnIsttInfoService01.MdcinClincTestInfoService01Grid.v2"
          }
        />

        <Column
          dataField="INSPCT_MANAGER_NAME"
          caption="시험책임자"
          dataType="string"
          groupIndex={0}
          groupCellRender={inspctManagerNameRender}
          // 시험책임자: 김소연 (Count:1)
        />
        <Column
          dataField="RESP_RESRC_OFTL1"
          caption="소속·직함"
          dataType="string"
        />
        <Column
          dataField="JOINT_STATUS"
          caption="책임 구분"
          dataType="string"
          width={100}
        />
        <Column
          dataField="CO_INSPCT_MANAGER_NAMES_DISPLAY"
          caption="공동책임자"
          dataType="string"
          cellRender={jointInvestigatorRender}
          width={160}
        />
        <Column
          dataField="SOURCE_INSPCT_MANAGER_NAME"
          caption="원문 책임자명"
          dataType="string"
          visible={false}
        />
        {/* <Column
          dataField="APPLY_ENTP_NAME"
          caption="신청자"
          dataType="string"
          // width={200}
        />
        <Column
          dataField="ORGN_DEV_BSSH_NM"
          caption="원개발사"
          dataType="string"
          // width={200}
        />
        <Column
          dataField="ORGN_DEV_NATN_CD_NM"
          caption="원개발사 국가"
          dataType="string"
        />
        <Column
          dataField="HIST_REG_DT"
          caption="최근(변경)승인일자"
          dataType="date"
          // width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="APPROVAL_TIME"
          caption="승인일"
          dataType="date"
          // width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="GOODS_NAME"
          caption="제품명"
          dataType="string"
          // width={200}
        />
        <Column
          dataField="CLINIC_EXAM_TITLE"
          caption="시험제목"
          dataType="string"
        />
        <Column
          dataField="CLINIC_EXAM_ENG_TITLE"
          caption="시험제목 (영문)"
          dataType="string"
        />
        <Column
          dataField="CLINIC_STEP_NAME"
          caption="단계"
          datatype="string"
          // width={150}
        >
          <Lookup
            dataSource={CLINIC_STEP_NAME}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="HMPG_ADDR"
          caption="모집공고 확인 홈페이지 주소"
          dataType="string"
        /> */}
        <Column
          dataField="APPLY_ENTP_NAME"
          caption="신청자"
          dataType="string"
          // width={200}
          cellRender={applyEntpNameRender}
        />
        <Column
          dataField="RPRSV_NMP"
          caption="임상시험 대표자"
          dataType="string"
        />
        <Column dataField="ADDR" caption="임상시험 소재지" dataType="string" />
        <Column
          dataField="ORGN_DEV_BSSH_NM"
          caption="원개발사"
          dataType="string"
          // width={200}
        />
        <Column
          dataField="ORGN_DEV_NATN_CD_NM"
          caption="원개발사 국가"
          dataType="string"
        />
        <Column
          dataField="HIST_REG_DT"
          caption="최근(변경)승인일자"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="APPROVAL_TIME"
          caption="승인일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        {/* <Column
          dataField="LAB_NAME"
          caption="실시기관[시험책임자]"
          dataType="string"
        /> */}
        <Column
          dataField="GOODS_NAME"
          caption="제품명"
          dataType="string"
          // width={200}
        />
        <Column dataField="GNRL_CD_NM" caption="성분명" dataType="string" />
        <Column
          dataField="CLINIC_EXAM_TITLE"
          caption="시험제목"
          dataType="string"
          width={500}
        />
        <Column
          dataField="CLINIC_EXAM_ENG_TITLE"
          caption="시험제목 (영문)"
          dataType="string"
          width={500}
        />
        <Column
          dataField="IVSGT_PURPS"
          caption="목적"
          dataType="string"
          width={500}
        />
        <Column dataField="CLST_PRPOS_CD_NM" caption="용도" dataType="string">
          <Lookup
            dataSource={CLST_PRPOS_CD_NM}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="DMINT_DIVS_CD_NM"
          caption="국내/국외개발"
          dataType="string"
        >
          <Lookup
            dataSource={DMINT_DIVS_CD_NM}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="CLNC_TEST_DTL_CD_NM"
          caption="상세구분 (다국가)"
          dataType="string"
        >
          <Lookup
            dataSource={CLNC_TEST_DTL_CD_NM}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="TRGT_DISS_CD_NM"
          caption="대상질환"
          dataType="string"
        />
        <Column
          dataField="TRGT_DISS_DTL_CD_NM"
          caption="대상질환 상세"
          dataType="string"
        />
        <Column
          dataField="TRGT_DISS_DTL_ETC"
          caption="대상질환 기타 직접입력"
          dataType="string"
        />
        <Column
          dataField="TRGT_DISS_NM"
          caption="대상질환명 (적응증)"
          dataType="string"
          width={500}
        />
        <Column
          dataField="DMST_PRMSN_YN"
          caption="국내허가여부"
          dataType="string"
        >
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column
          dataField="COMP_DRUG_YN"
          caption="활성대조약여부"
          dataType="string"
        >
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column
          dataField="FRST_INDV_TRGT_IVSGT_YN"
          caption="최초사람대상여부"
          dataType="string"
        >
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column dataField="CPDR_YN" caption="대조약여부" dataType="string">
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column dataField="PLCB_YN" caption="위약여부" dataType="string">
          <Lookup dataSource={YN} displayExpr="name" valueExpr="name" />
        </Column>
        <Column
          dataField="COMP_DRUG_NM"
          caption="대조약제품명"
          dataType="string"
        />
        <Column dataField="SHAPE_CD" caption="제형" dataType="string" />
        <Column
          dataField="CLINIC_STEP_NAME"
          caption="단계"
          datatype="string"
          // width={150}
          groupIndex={1}
        >
          <Lookup
            dataSource={CLINIC_STEP_NAME}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column
          dataField="CLINIC_TYPE_CD_NM"
          caption="임상시험형태"
          type="string"
        />
        <Column dataField="CLINICAL_PERIOD" caption="기간" type="string" />
        <Column
          dataField="TESTEE_CNT_INFO"
          caption="목표대상자수 (국내 대상자수)"
          type="string"
        />
        <Column
          dataField="RNDM_ASSG_CD_NM"
          caption="무작위배정여부"
          type="string"
        >
          <Lookup
            dataSource={RNDM_ASSG_CD_NM}
            displayExpr="name"
            valueExpr="name"
          />
        </Column>
        <Column dataField="BLND_CD_NM" caption="눈가림종류" type="string">
          <Lookup dataSource={BLND_CD_NM} displayExpr="name" valueExpr="name" />
        </Column>
        <Column
          dataField="ARBTR_GRP_NUM"
          caption="중재군수"
          type="number"
          alignment="right"
        />
        <Column
          dataField="CLST_BGNG_DT"
          caption="최초 시험대상자 선정일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="LAST_TRGTER_SLCTN_DT"
          caption="최종 시험대상자 선정일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="CLST_END_DT"
          caption="최종 시험대상자 관찰 종료일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="TEST_COMPLETION_DT"
          caption="실제 시험 완료일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="RESULT_REPORT_SUBMIT_DT"
          caption="결과보고 제출일"
          dataType="date"
          width={150}
          format="yyyy-MM-dd"
        />
        <Column
          dataField="PRIM_EVL_VAR"
          caption="1차 유효성 평가변수"
          type="string"
          width={500}
        />
        <Column
          dataField="SCND_EVL_VAR"
          caption="2차 유효성 평가변수"
          type="string"
          width={500}
        />
        <Column dataField="DOSAGE_TERM_TS" caption="투여기간" type="string" />
        <Column
          dataField="CLST_MTH_INFO"
          caption="투여방법"
          type="string"
          width={500}
        />
        <Column dataField="STATUS" caption="진행현황" type="string" />
        <Column
          dataField="HMPG_ADDR"
          caption="모집공고 확인 홈페이지 주소"
          dataType="string"
        />

        <Toolbar>
          <Item location="before" name="groupPanel" />
          {/* <Item location="after">
            <Button icon="blind.png" onClick={handleBlind} />
          </Item> */}
          <Item location="after">
            <Button icon="exportpdf" onClick={exportGrid} />
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
          <Item name="searchPanel" />
        </Toolbar>

        <Export enabled={true} />

        <Summary>
          <GroupItem column="APPLY_ENTP_NAME" summaryType="count" />
        </Summary>
        <SortByGroupSummaryInfo summaryItem="count" sortOrder="desc" />

        <Pager
          allowedPageSizes={pageSize}
          showPageSizeSelector={true}
          showInfo={true}
        />
        <Paging defaultPageSize={10} />
      </DataGrid>
    </React.Fragment>
  );
}
